import APIRequestState from '../_util/api-request';

class UpdateAccountState extends APIRequestState {
  get method() { return 'PUT'; }
  get url() { return '/me'; }
}

export default UpdateAccountState;



// WEBPACK FOOTER //
// ./spa/state/session/update.jsx